import ViewCampaigns from "@/models/loyaltyPanel/campaigns/ViewCampaigns";

export default {
    namespaced: true,

    state: () => ({
        campaigns: [],
        campaign: {},
        participants: [],
        participantInfo: {},
        participantsPagination: {},
        campaignStatuses: [],
        systemNotifications: [],
        campaignTypes: [],
        transactionTypes: [],
        campaignConditions: [],
        clientCharacteristics: [],
        stores: [],
        exportedFile: null


    }),

    getters: {
        campaigns: state => state.campaigns,
        campaign: state => state.campaign,
        participants: state => state.participants,
        participantInfo: state => state.participantInfo,
        participantsPagination: state => state.participantsPagination,
        campaignStatuses: state => state.campaignStatuses,
        systemNotifications: state => state.systemNotifications,
        campaignTypes: state => state.campaignTypes,
        transactionTypes: state => state.transactionTypes,
        campaignConditions: state => state.campaignConditions,
        clientCharacteristics: state => state.clientCharacteristics,
        stores: state => state.stores,
    },
    mutations: {
        setCampaigns(state, payload){
            state.campaigns = payload;
        },

        setCampaign(state, payload){
            state.campaign = payload;
        },

        setCampaignStatuses(state, payload){
            state.campaignStatuses = payload;
        },
        
        setParticipants(state, payload){
            state.participants = payload;
        },
        
        setParticipantInfo(state, payload){
            state.participantInfo = payload;
        },
        
        setParticipantsPagination(state, payload){
            state.participantsPagination = payload;
        },

        setSystemNotifications(state, payload) {
            state.systemNotifications = payload;
        },
        setCampaignTypes(state, payload) {
            state.campaignTypes = payload;
        },
        setTransactionTypes(state, payload) {
            state.transactionTypes = payload;
        },
        setCampaignConditions(state, payload){
            state.campaignConditions = payload;
        },
        setClientCharacteristics(state, payload){
            state.clientCharacteristics = payload;
        },
        
        setStores(state, payload) {
            state.stores = payload;
        },
        
        setExportedFile(state, payload) {
            state.exportedFile =payload;
        }
    },

    actions: {
        async getCampaigns({ commit }, payload) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await ViewCampaigns.get(payload);
                const { campaigns,pagination } = data.data;

                for(let i in campaigns){
                    for(let p in campaigns[i]){
                        campaigns[i][p] = campaigns[i][p] ? campaigns[i][p]  : '-';
                    }
                }
                commit("setCampaigns", campaigns);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },

        async getCampaignStatuses({ commit }) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await ViewCampaigns.getCampaignStatuses();

                commit("setCampaignStatuses", data.data);
              
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },
        
        async getCampaignTypes({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await ViewCampaigns.getCampaignTypes();
                // let array = []
                // for (const key in data.data) {
                //     data.data[key].category = key
                //     array.push(data.data[key])
                //         }
                // const campaignTypes = array;
                const campaignTypes = data.data;
                commit("setCampaignTypes", campaignTypes);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },
        async getTransactionTypes({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await ViewCampaigns.getTransactionTypes();

                commit("setTransactionTypes", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },
        async getClientCharacteristics({ commit }, typeId) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await ViewCampaigns.getClientCharacteristics(typeId);
                data.data.unshift({
                    name: "No Sub-Condition Needed",
                    campaign_client_characteristic_id: null,
                    system: "none"
                })
                commit("setClientCharacteristics", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },

        async getCampaignConditions({ commit, state }, id) {
            try {
                commit("setLoading", true, { root: true });

                const {data} = await ViewCampaigns.getConditions(id);
                commit("setCampaignConditions", data.data);

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setErrorMessage",
                    ex.response.data.message, { root: true }
                );
            }
        },
        async getParticipants({ commit }, payload) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await ViewCampaigns.getParticipants(payload);
                const { campaign_participants, pagination } = data.data;

                commit("setParticipants", campaign_participants);
                commit("setParticipantsPagination", pagination);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },
        
        async refreshReward({ commit }, payload) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await ViewCampaigns.refreshReward(payload);
               
                commit("setLoading", false, { root: true });
                return data.code == 200

            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },

        async getCampaignSystemNotifications({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await ViewCampaigns.getCampaignSystemNotifications();
                const systemNotifications = data.data;
                commit("setSystemNotifications", systemNotifications);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getSingleCampaign({ commit, state }, id) {
            try {
                commit("setLoading", true, { root: true });
                if(state.campaign.campaign_id != id){
                    commit("setCampaign", {});
                }
                const { data } = await ViewCampaigns.getCampaign(id);
                commit("setCampaign", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },

        async changeCampaignStatus({ commit, state }, body) {
            try {
                commit("setLoading", true, { root: true });
                let data = await ViewCampaigns.changeStatus(body);
                if(data.data?.status_changed){
                    let campaign = state.campaign
                    campaign.campaign_status_id = body.campaign_status_id
                    commit("setCampaign", campaign);
                }
                commit("setLoading", false, { root: true });
                commit("setDialog", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "success",
                        text: "You have successfully changed status!"
                    },

                        { root: true }
                    );
                    return data
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                        { root: true }
                    );
                    return false
            }
        },
        
        async getParticipant({ commit }, payload) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await ViewCampaigns.getParticipant(payload);
                commit("setParticipantInfo", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },
        
        async getStoresByIds({ commit, state }, ids) {
            try {
                commit("setLoading", true, { root: true });
                let stores = []
                commit("setStores", stores);

                for (let id of ids) {
                    let { data } = await ViewCampaigns.getStore(id);
                    stores.push(data.data.store)
                }

                commit("setStores", stores);

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
            }
        },
        
        async updateNotificationText({ commit, state }, payload) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await ViewCampaigns.updateNotificationText(state.campaign.campaign_id, payload);
                commit("setParticipantInfo", data.data);
                commit("setLoading", false, { root: true });
                return data
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex.response.data);
                return ex.response
            }
        },
        
        async saveRewardSms({ commit, state }, payload) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await ViewCampaigns.saveRewardSms(payload);
                commit("setParticipantInfo", data.data);
                commit("setLoading", false, { root: true });
                return data
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex);
                return ex.response
            }
        },
        
        async updateCampaignTypeOptions({ commit, dispatch }, payload) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await ViewCampaigns.updateCampaignTypeOptions(payload);

                await dispatch("getSingleCampaign", payload.campaign_id)
                commit("setLoading", false, { root: true });
                
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex);
                return ex.response
            }
        },

        async exportFile({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                const data = await ViewCampaigns.exportFile(body)
                commit("setExportedFile", data.data.data)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },
        async getExportedFile({ commit }) {
            try {
                const data = await ViewCampaigns.getExportedFile()
                commit("setExportedFile", data.data.data)
            } catch (ex) {
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async deleteExportedFile({ commit }, id) {
            try {
                commit("setLoading", true, { root: true });

                await ViewCampaigns.deleteExportedFile(id)
                commit("setExportedFile", null)

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },

        async updateCampaignSettings({ commit, dispatch }, payload) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await ViewCampaigns.updateCampaignSettings(payload);

                await dispatch("getSingleCampaign", payload.campaign_id)
                commit("setLoading", false, { root: true });
                return data
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex);
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message || "Error"
                    },

                        { root: true }
                    );
                return ex.response
            }
        },

        async updateBilling({ commit, dispatch }, {id, billable}) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await ViewCampaigns.updateBilling(id, billable);

                await dispatch("getSingleCampaign", id)
                commit("setLoading", false, { root: true });
                return data
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex);
                return ex.response?.data
            }
        },
    }
};
